{
  "schemaVersion": 1,
  "chartTypes": ["candles", "bars", "line", "area"],
  "themeModes": ["light", "dark", "system"],
  "sessions": ["regular", "extended"],
  "crosshairModes": ["full", "magnet", "off"],
  "layoutPresets": ["single", "two-horizontal", "two-vertical", "four-grid"],
  "panePlacements": ["auto", "main", "new-pane"],
  "fontFamilyKeys": ["system", "inter", "roboto-mono"],
  "features": [
    "object-tree", "indicator-manager", "drawing-toolbar", "alerts",
    "watchlists", "templates", "chart-settings", "go-to-date", "clock",
    "account", "market-data"
  ],
  "toolbarRegions": ["top", "left", "right", "bottom"],
  "commands": [
    { "id": "symbol-search", "regions": ["top"], "mandatoryIn": ["top"] },
    { "id": "new-chart", "regions": ["top"] },
    { "id": "watchlists", "regions": ["top"], "feature": "watchlists", "capability": "watchlists" },
    { "id": "alerts", "regions": ["top"], "feature": "alerts", "capability": "alerts" },
    { "id": "object-tree", "regions": ["top"], "feature": "object-tree" },
    { "id": "account", "regions": ["top"], "feature": "account" },
    { "id": "market-state", "regions": ["top"] },
    { "id": "focus-chart", "regions": ["left"], "mandatoryIn": ["left"] },
    { "id": "drawings", "regions": ["left"], "feature": "drawing-toolbar", "capability": "drawings" },
    { "id": "zoom-in", "regions": ["left"] },
    { "id": "zoom-out", "regions": ["left"] },
    { "id": "reset-view", "regions": ["left"] },
    { "id": "indicators", "regions": ["right"], "feature": "indicator-manager", "capability": "indicators" },
    { "id": "reset-layout", "regions": ["right"] },
    { "id": "theme-toggle", "regions": ["right"] },
    { "id": "fullscreen", "regions": ["right"] },
    { "id": "market-data-status", "regions": ["bottom"], "feature": "market-data" },
    { "id": "workspace-status", "regions": ["bottom"] },
    { "id": "render-status", "regions": ["bottom"] },
    { "id": "clock", "regions": ["bottom"], "feature": "clock" }
  ]
}
